export default __webpack_public_path__ + "static/media/image6.0be52e29.jpg";